module.exports = "/images/eit_eu_logo.png?4781bd03a4d88e8ecec5e1d2eeb4403c";